import { c as _c } from "react/compiler-runtime";
import { atom, useAtom } from 'jotai';
const signInDialogAtom = atom(false);
export function useSignInDialog() {
  const $ = _c(8);
  const [open, setOpen] = useAtom(signInDialogAtom);
  let t0;
  let t1;
  if ($[0] !== setOpen) {
    t0 = () => {
      setOpen(true);
    };
    t1 = () => {
      setOpen(false);
    };
    $[0] = setOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== open || $[4] !== setOpen || $[5] !== t0 || $[6] !== t1) {
    t2 = {
      open,
      setOpen,
      openDialog: t0,
      closeDialog: t1
    };
    $[3] = open;
    $[4] = setOpen;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}